import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: "app-date-filter",
  templateUrl: "./date-filter.component.html",
  styleUrls: ["./date-filter.component.css"],
})
export class DateFilterComponent implements OnInit {
  @Output() filteredDateType: EventEmitter<any> = new EventEmitter();

  activeAllFlag: boolean = false;
  activeYearFlag: boolean = false;
  activeLastYearFlag: boolean = false;
  activeMonthFlag: boolean = false;
  activeWeekFlag: boolean = false;
  activeTodayFlag: boolean = false;

  customFlag: boolean = false;

  disablePrev: boolean = false;
  disableNext: boolean = true;
  disableNextWeek: boolean = true;
  disableNextMonth: boolean = true;
  disableNextYear: boolean = true;

  minDate: Date = new Date("2019-10-01");
  today: Date = new Date();
  currentDate: Date = new Date();
  currentWeekDate: Date = new Date();
  currentMonthDate: Date = new Date();
  currentYearDate: Date = new Date();

  filterOptions = [
    {
      title: "all",
      value: "all",
      date: "",
    },
    {
      title: "daily",
      value: "today",
      date: this.currentDate,
    },
    {
      title: "weekly",
      value: "week",
      date: this.currentWeekDate,
    },
    {
      title: "monthly",
      value: "month",
      date: this.currentMonthDate,
    },
    {
      title: "yearly",
      value: "year",
      date: this.currentYearDate,
    },
  ];

  monthList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  yearList = [];

  selectedOption = "today";
  selectedMonth = this.currentMonthDate.getMonth();
  selectedMonthYear = this.currentMonthDate.getFullYear();
  selectedYear = this.currentYearDate.getFullYear();

  constructor() {}

  ngOnInit() {
    for (let i = 2019; i <= 2024; i++) {
      this.yearList.push(i);
    }
  }

  disablePrevMonth(month) {
    let disable = false;
    if (this.currentMonthDate.getFullYear() === 2019 && month < 9) {
      disable = true;
    }
    return disable;
  }

  prevNextDailyReport(type) {
    let date = new Date(this.currentDate);

    switch (type) {
      case "prev":
        date.setDate(this.currentDate.getDate() - 1);
        break;
      case "next":
        date.setDate(this.currentDate.getDate() + 1);
        break;
      default:
        break;
    }

    this.currentDate = date;

    this.minDate.setHours(0, 0, 0, 0);
    this.today.setHours(0, 0, 0, 0);
    this.currentDate.setHours(0, 0, 0, 0);

    this.disablePrev =
      this.minDate.getTime() === this.currentDate.getTime() ? true : false;

    this.disableNext =
      this.today.getTime() <= this.currentDate.getTime() ? true : false;

    this.emitDateType("today", this.currentDate);
  }

  prevNextWeeklyReport(type) {
    let date = new Date(this.currentWeekDate);

    switch (type) {
      case "prev":
        date.setDate(this.currentWeekDate.getDate() - 7);
        break;
      case "next":
        date.setDate(this.currentWeekDate.getDate() + 7);
        break;
      default:
        break;
    }

    this.currentWeekDate = date;

    this.today.setHours(0, 0, 0, 0);
    this.currentWeekDate.setHours(0, 0, 0, 0);

    this.disableNextWeek =
      this.today.getTime() <= this.currentWeekDate.getTime() ? true : false;

    this.emitDateType("week", this.currentWeekDate);
  }

  prevNextMonthReport(type, month, year) {
    let date = new Date(this.currentMonthDate);

    switch (type) {
      case "prev":
        date.setMonth(this.currentMonthDate.getMonth() - 1);
        break;
      case "next":
        date.setMonth(this.currentMonthDate.getMonth() + 1);
        break;
      default:
        date.setMonth(month);
        date.setFullYear(year);
        break;
    }

    this.currentMonthDate = date;

    this.selectedMonth = this.currentMonthDate.getMonth();
    this.selectedMonthYear = this.currentMonthDate.getFullYear();

    this.today.setHours(0, 0, 0, 0);
    this.currentMonthDate.setHours(0, 0, 0, 0);

    this.disableNextMonth =
      this.today.getTime() <= this.currentMonthDate.getTime() ? true : false;

    this.emitDateType("month", this.currentMonthDate);
  }

  prevNextYearReport(type, year) {
    let date = new Date(this.currentYearDate);

    switch (type) {
      case "prev":
        date.setFullYear(this.currentYearDate.getFullYear() - 1);
        break;
      case "next":
        date.setFullYear(this.currentYearDate.getFullYear() + 1);
        break;
      default:
        date.setFullYear(year);
        break;
    }

    this.currentYearDate = date;
    this.selectedYear = this.currentYearDate.getFullYear();

    this.today.setHours(0, 0, 0, 0);
    this.currentYearDate.setHours(0, 0, 0, 0);

    this.disableNextYear =
      this.today.getTime() <= this.currentYearDate.getTime() ? true : false;

    this.emitDateType("year", this.currentYearDate);
  }

  getCurrentWeekDates() {
    let ws = new Date(this.getWeekRange(this.currentWeekDate).firstDay);
    let weekStartDate = ws.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
    let wl = new Date(this.getWeekRange(this.currentWeekDate).lastDay);
    let weekLastDate = wl.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });

    return weekStartDate + " - " + weekLastDate;
  }

  getCurrentMonth() {
    return this.currentMonthDate.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });
  }

  getWeekRange(selectedDate) {
    const today = new Date(selectedDate);

    // Get the current day of the week (0 - Sunday, 6 - Saturday)
    const currentDayOfWeek = today.getDay();

    // Calculate the difference to get to Sunday (start of the week)
    const firstDayDiff = currentDayOfWeek;
    const lastDayDiff = 6 - currentDayOfWeek;

    // Calculate the first and last day of the week
    const firstDayOfWeek = new Date(today);
    const lastDayOfWeek = new Date(today);

    firstDayOfWeek.setDate(today.getDate() - firstDayDiff);
    lastDayOfWeek.setDate(today.getDate() + lastDayDiff);

    return {
      firstDay: firstDayOfWeek,
      lastDay: lastDayOfWeek,
    };
  }

  emitDateType(type, date) {
    this.filteredDateType.emit({ type: type, date: date });
  }
}



// WEBPACK FOOTER //
// ./src/app/date-filter/date-filter.component.ts